import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { salesCoverageSchema, SalesCoverageSchema } from '@retail/markup/components';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { Stack } from '@mui/material';
import { HelperText } from '@shared/components';
import { StyledTextField } from '../../CalculusInfoRow';
import { ConfirmEditButtons } from '../../../ConfirmEditButtons';

interface Props {
  defaultValue: number;
  onSubmit: (value: number) => void;
  onCancel: () => void;
}

export const SalesCoverageInput: FC<Props> = ({ defaultValue, onSubmit, onCancel }) => {
  const t = useCalculusTFunction();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<SalesCoverageSchema>({
    defaultValues: { salesCoverage: defaultValue },
    resolver: yupResolver(salesCoverageSchema(t)),
  });

  const _onSubmit = handleSubmit(({ salesCoverage }) => {
    onSubmit(salesCoverage);
  });

  return (
    <Stack alignItems="flex-end">
      <Stack direction="row" alignItems="center" gap={1}>
        <StyledTextField
          {...register('salesCoverage')}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (e.code === 'Enter') {
              _onSubmit();
            }
          }}
          autoFocus
          size="small"
          error={!!errors.salesCoverage?.message}
        />
        <ConfirmEditButtons onSubmit={_onSubmit} onCancel={onCancel} />
      </Stack>
      {errors.salesCoverage?.message && (
        <HelperText id="salesCoverageInputError" status="error">
          {errors.salesCoverage?.message}
        </HelperText>
      )}
    </Stack>
  );
};
